// extracted by mini-css-extract-plugin
export var calendarView = "_gf-0";